export const truncateText = (text, maxLength = 25) => {
  if (!text || typeof text !== "string") return "";

  if (text.length <= maxLength) return text;

  return text.slice(0, maxLength).trim() + "...";
}
